import React from 'react';

import { TableBody } from '@mui/material';

import { ISalesDetails } from '../../../../types/sales-details.type';
import SalesDetailsListItem from '../SalesDetailsListItem';

interface IProps {
  details: ISalesDetails[];
}

const SalesDetailsListBody = React.memo(({ details }: IProps) => (
  <TableBody>
    {details.map((detail) => (
      <SalesDetailsListItem detail={detail} key={detail.number} />
    ))}
  </TableBody>
));

export default SalesDetailsListBody;
